import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M0 5400 l0 -5400 5400 0 5400 0 0 5400 0 5400 -5400 0 -5400 0 0
-5400z m5773 3205 c165 -21 306 -49 467 -95 126 -37 179 -54 321 -109 153 -58
431 -209 589 -320 246 -171 529 -445 699 -675 56 -75 151 -216 151 -222 0 -3
10 -19 21 -36 46 -63 166 -304 217 -433 217 -550 273 -1104 172 -1695 -27
-161 -138 -528 -161 -538 -5 -2 -6 -9 -3 -16 3 -7 -2 -19 -11 -26 -8 -7 -15
-21 -15 -32 0 -10 -8 -33 -17 -51 -9 -18 -18 -34 -18 -37 -1 -3 -7 -18 -13
-33 -7 -16 -12 -33 -12 -38 0 -5 -10 -9 -22 -10 -13 0 -17 -3 -10 -6 14 -5 17
-33 3 -33 -5 0 -12 6 -14 13 -3 6 -6 -4 -7 -23 -1 -34 -22 -75 -32 -65 -3 3
-22 6 -42 7 -23 1 -36 6 -36 15 0 8 -12 13 -34 13 -26 0 -36 -5 -41 -20 -4
-13 -15 -20 -32 -20 -18 0 -24 -4 -19 -15 3 -10 -1 -18 -12 -22 -9 -4 -20 -11
-24 -17 -5 -7 -8 -5 -8 6 0 9 -3 24 -7 34 -5 13 -3 16 10 11 11 -4 17 -1 17 7
0 8 7 16 15 20 8 3 15 12 15 21 0 18 17 20 23 3 2 -7 8 -10 13 -5 4 4 0 15
-10 25 -16 16 -18 16 -36 -8 -18 -23 -19 -23 -14 -3 3 12 15 31 25 42 11 12
17 21 14 21 -4 0 5 21 18 48 14 26 32 65 42 87 9 22 27 63 40 90 32 67 108
299 133 405 45 193 52 231 67 363 17 160 20 432 5 592 -45 489 -226 971 -515
1375 -430 601 -1098 1014 -1835 1136 -301 49 -689 41 -995 -21 -730 -148
-1367 -575 -1784 -1196 -257 -384 -421 -848 -462 -1310 -12 -141 -6 -520 10
-614 5 -27 14 -79 20 -115 6 -36 17 -95 26 -130 8 -36 20 -87 26 -115 17 -75
88 -282 120 -351 16 -34 29 -70 29 -80 0 -11 9 -32 20 -49 12 -16 28 -45 37
-64 15 -31 15 -35 0 -46 -9 -7 -17 -18 -16 -26 0 -10 2 -11 6 -1 10 25 34 11
53 -30 11 -24 20 -36 20 -28 0 8 9 -3 21 -25 12 -22 25 -44 30 -50 12 -13 11
-38 -1 -30 -6 4 -8 9 -6 13 2 4 -7 23 -20 42 -20 29 -24 31 -24 13 0 -12 7
-28 15 -37 17 -16 20 -56 5 -56 -5 0 -10 11 -10 25 0 13 -11 34 -24 47 -26 26
-40 58 -25 58 6 0 7 5 3 11 -4 8 -9 8 -17 0 -6 -6 -35 -11 -65 -11 l-54 0 5
-29 c5 -21 2 -31 -10 -35 -14 -6 -14 -8 2 -20 10 -7 15 -19 12 -27 -4 -10 -6
-9 -6 4 -1 12 -7 17 -18 15 -19 -4 -42 37 -44 76 0 20 -1 20 -9 1 -5 -11 -9
-14 -9 -7 -1 6 0 13 1 15 1 1 -11 21 -25 44 -15 24 -27 49 -27 57 0 8 -4 16
-9 18 -12 4 -102 219 -144 348 -261 781 -191 1632 193 2367 154 295 297 489
535 728 150 151 167 167 290 264 306 243 700 439 1095 544 202 54 368 81 635
101 91 7 394 -4 518 -19z m-63 -286 c395 -37 876 -211 1220 -441 329 -221 605
-500 813 -823 58 -90 169 -302 214 -408 165 -388 241 -833 214 -1247 -13 -200
-22 -256 -88 -558 -3 -12 -9 -25 -14 -28 -5 -3 -9 -15 -9 -27 -1 -36 -45 -158
-55 -150 -4 4 -5 3 -2 -3 7 -13 -49 -157 -110 -282 -43 -87 -66 -118 -43 -58
6 18 6 25 0 21 -5 -3 -13 -24 -16 -45 -4 -22 -11 -37 -16 -34 -5 3 -16 -2 -23
-12 -14 -18 -14 -18 -15 1 -1 13 -4 15 -7 6 -5 -11 -7 -11 -14 0 -8 12 -11 11
-19 -1 -5 -8 -8 -21 -5 -28 3 -7 0 -10 -6 -7 -27 17 -29 55 -5 101 14 28 26
41 29 33 2 -8 3 -5 1 7 -4 24 51 130 65 127 6 -2 11 2 11 7 0 6 -5 10 -11 10
-8 0 -8 4 -2 13 8 10 34 76 74 187 67 187 125 487 139 715 9 156 -1 426 -20
525 -6 30 -15 84 -20 120 -13 91 -73 304 -122 435 -193 517 -550 967 -1008
1270 -400 265 -835 409 -1314 435 -619 33 -1234 -153 -1726 -524 -30 -22 -57
-43 -60 -46 -3 -3 -30 -25 -60 -50 -71 -58 -220 -207 -290 -290 -30 -36 -58
-67 -61 -70 -9 -7 -128 -174 -172 -242 -89 -136 -218 -409 -270 -573 -49 -156
-56 -182 -76 -275 -46 -222 -55 -308 -55 -550 0 -194 4 -263 23 -394 23 -156
73 -360 125 -503 14 -40 26 -79 26 -88 0 -8 3 -15 8 -15 8 0 33 -65 35 -92 1
-10 5 -18 9 -18 6 0 42 -68 77 -145 2 -5 -4 -2 -13 8 -24 24 -27 22 -15 -13
11 -32 24 -39 32 -17 3 8 7 7 12 -5 5 -12 -2 -26 -23 -45 -16 -15 -32 -35 -34
-43 -3 -9 -8 -2 -12 18 -5 19 -14 32 -23 32 -12 0 -13 -3 -3 -15 6 -8 10 -20
7 -27 -3 -7 -12 3 -20 23 -9 19 -23 41 -31 49 -9 7 -16 20 -15 29 0 11 3 9 9
-6 14 -36 19 -27 7 12 -8 27 -13 32 -24 24 -10 -9 -13 -7 -13 6 0 9 -8 29 -18
43 -11 15 -32 61 -47 102 -15 41 -36 94 -46 117 -11 23 -31 80 -45 125 -14 46
-34 112 -45 148 -11 36 -34 146 -51 245 -29 169 -31 196 -32 445 -1 210 3 288
17 375 59 359 137 605 282 891 198 390 490 730 843 983 219 157 416 261 667
354 407 151 803 199 1265 156z m412 -1489 c248 -744 397 -1197 402 -1225 2
-11 10 -36 18 -55 8 -19 13 -41 11 -47 -4 -10 -235 -13 -1113 -13 -835 0
-1109 -3 -1112 -12 -3 -7 -9 -5 -19 6 -7 9 -22 25 -32 35 -17 18 -17 22 13
112 16 52 33 101 37 109 3 8 7 22 9 31 2 8 32 103 68 210 35 107 69 210 75
229 5 19 39 120 75 225 35 104 62 193 60 197 -3 5 -140 8 -305 8 l-299 0 0
388 c0 214 3 392 7 395 3 4 434 6 956 5 l950 -3 199 -595z m-903 -2457 c90
-66 96 -245 10 -329 l-39 -38 -100 -4 -100 -4 0 202 0 203 101 -6 c78 -4 108
-10 128 -24z m330 -40 c39 -132 91 -317 91 -325 0 -4 -26 -8 -58 -8 l-59 0
-14 63 -14 62 -42 3 c-39 3 -41 2 -48 -30 -18 -89 -24 -98 -66 -98 -21 0 -39
4 -39 8 0 11 110 374 116 384 3 4 30 8 59 8 l54 0 20 -67z m359 10 c2 -29 -1
-53 -5 -53 -4 0 -21 9 -38 20 -54 36 -55 35 -55 -145 l0 -165 -55 0 -55 0 0
165 c0 108 -4 165 -10 165 -6 0 -28 -9 -50 -20 -22 -11 -42 -20 -45 -20 -3 0
-5 25 -5 55 l0 56 158 -3 157 -3 3 -52z m197 46 c4 -5 31 -94 59 -197 l53
-187 -50 -3 c-27 -2 -55 -1 -62 2 -7 2 -17 32 -24 66 l-12 61 -42 -3 -42 -3
-14 -62 -14 -63 -45 0 c-33 0 -43 3 -39 14 3 7 15 47 27 87 12 41 37 125 56
187 l35 112 54 0 c30 0 57 -5 60 -11z m455 -8 c31 -6 35 -11 38 -40 3 -30 2
-32 -20 -25 -13 5 -43 9 -68 9 -39 0 -45 -3 -48 -22 -2 -17 10 -31 57 -62 73
-50 91 -74 91 -123 0 -30 -8 -47 -34 -76 -33 -36 -37 -37 -103 -37 -103 0
-123 8 -123 50 l0 34 41 -14 c50 -18 81 -19 97 -3 22 22 13 37 -50 83 -71 52
-87 75 -88 126 0 43 30 85 74 105 29 12 49 12 136 -5z m200 -139 c0 -166 4
-182 46 -182 38 0 43 20 46 181 l3 154 40 0 40 0 0 -167 0 -168 -33 -32 c-31
-31 -36 -33 -107 -33 -71 0 -76 2 -107 33 l-33 32 -3 156 c-2 86 -1 162 2 170
4 9 22 14 56 14 l50 0 0 -158z m468 132 c47 -31 53 -118 10 -149 l-22 -15 27
-28 c35 -37 43 -80 23 -120 -26 -50 -61 -62 -176 -62 l-100 0 0 195 0 194 63
4 c85 5 147 -2 175 -19z m-3340 -64 c34 -92 62 -195 62 -225 0 -26 -15 -34
-23 -12 -3 9 -7 9 -20 -2 -13 -10 -20 -11 -31 -1 -22 17 -104 20 -121 4 -18
-18 -25 -18 -25 1 0 13 -3 13 -21 3 -15 -9 -23 -10 -25 -2 -3 5 -18 9 -34 8
-17 -1 -30 1 -30 4 0 4 9 36 20 72 28 91 28 90 -30 90 l-50 0 0 65 0 66 152
-3 153 -3 23 -65z m274 -7 l3 -78 65 0 65 0 0 75 0 75 152 3 152 3 27 -41 c15
-22 29 -40 33 -40 3 1 18 19 33 40 28 40 28 40 93 40 36 0 65 -4 65 -9 0 -4
-29 -51 -64 -102 -54 -80 -84 -151 -78 -181 2 -9 -13 -11 -42 -8 -10 1 -23 -4
-27 -12 -6 -9 -9 -6 -10 12 l-1 25 -7 -25 c-7 -20 -9 -14 -16 35 -5 40 -16 69
-31 88 -13 16 -24 33 -24 38 0 5 -31 9 -70 9 l-70 0 0 -85 0 -85 -45 0 c-29 0
-45 4 -45 13 0 8 -4 7 -10 -3 -7 -11 -10 -7 -10 18 l0 32 -70 0 -70 0 0 -30
c0 -28 -2 -30 -40 -30 -25 0 -40 -5 -41 -12 -1 -7 -5 -2 -9 12 l-8 25 -2 -25
c-3 -33 -18 61 -19 123 -1 40 -4 47 -21 47 -18 0 -20 7 -20 65 l0 65 80 0 79
0 3 -77z m-1017 -124 c4 -12 2 -26 -4 -32 -8 -8 -11 -2 -12 24 -1 23 -3 27 -6
12 -6 -34 -23 -28 -23 7 0 27 2 30 19 20 11 -5 23 -19 26 -31z m4675 27 c0 -3
-4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-37 -26
c3 -11 1 -20 -4 -20 -4 0 -7 -6 -5 -12 1 -7 1 -10 -1 -6 -2 4 -10 5 -18 2 -7
-3 -16 -1 -20 5 -3 7 3 11 15 11 17 0 20 4 15 20 -3 11 -2 20 3 20 5 0 12 -9
15 -20z m-121 -12 c-7 -7 -12 -8 -12 -2 0 14 12 26 19 19 2 -3 -1 -11 -7 -17z
m-4628 -24 c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z m146 -20
c0 -8 -4 -12 -10 -9 -5 3 -10 10 -10 16 0 5 5 9 10 9 6 0 10 -7 10 -16z m4473
6 c-14 -6 -23 -19 -24 -32 -1 -18 -2 -19 -6 -5 -6 22 14 47 36 46 11 0 9 -3
-6 -9z m-4573 -26 c0 -8 -4 -12 -10 -9 -5 3 -10 10 -10 16 0 5 5 9 10 9 6 0
10 -7 10 -16z m85 -14 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3
0 8 -4 11 -10z m4795 0 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10
10 6 0 10 -4 10 -10z m-4862 -24 c-7 -8 -15 -12 -17 -11 -5 6 10 25 20 25 5 0
4 -6 -3 -14z m4962 7 c0 -5 -5 -15 -10 -23 -8 -12 -10 -11 -10 8 0 12 5 22 10
22 6 0 10 -3 10 -7z m-373 -35 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12
1 -19z m105 0 c-7 -7 -12 -8 -12 -2 0 14 12 26 19 19 2 -3 -1 -11 -7 -17z
m215 -10 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-4939 -43 c-3
-3 -9 2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z m4879 -37 c-3 -8 -6 -5 -6
6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m43 7 c-7 -9 -15 -13 -19 -10 -3 3 1 10
9 15 21 14 24 12 10 -5z m-40 -65 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8
10 11 10 2 0 4 -4 4 -10z"/>
<path d="M7956 4345 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M2631 4333 c-1 -7 8 -17 19 -23 14 -7 20 -7 20 0 0 5 -6 10 -14 10
-8 0 -17 6 -19 13 -4 9 -6 9 -6 0z"/>
<path d="M2686 4253 c4 -16 13 -37 20 -48 12 -16 14 -17 14 -3 0 9 -5 20 -10
23 -6 4 -8 10 -5 15 7 11 -5 40 -16 40 -5 0 -6 -12 -3 -27z"/>
<path d="M7911 4254 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8060 4222 c0 -11 7 -23 16 -26 11 -4 15 0 12 16 -4 28 -28 36 -28
10z"/>
<path d="M2750 4143 c0 -23 15 -39 24 -25 3 5 -1 18 -9 28 -14 18 -14 18 -15
-3z"/>
<path d="M7926 4463 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M7880 4389 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M7726 4274 c-11 -28 -7 -35 13 -22 10 6 17 18 14 25 -7 18 -20 16
-27 -3z"/>
<path d="M3041 4264 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5363 6388 c-79 -233 -193 -558 -212 -608 -11 -30 -17 -58 -13 -62
10 -10 516 -13 531 -3 6 3 -3 43 -25 103 -35 97 -139 396 -197 570 -17 50 -36
92 -42 92 -6 0 -25 -42 -42 -92z"/>
<path d="M6492 5540 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M6398 5528 c9 -9 15 -9 24 0 9 9 7 12 -12 12 -19 0 -21 -3 -12 -12z"/>
<path d="M5100 4199 c0 -140 0 -140 23 -137 69 10 79 242 11 268 -14 6 -27 10
-30 10 -2 0 -4 -63 -4 -141z"/>
<path d="M5442 4245 c-16 -55 -15 -65 7 -65 27 0 30 8 16 60 l-12 45 -11 -40z"/>
<path d="M6013 4231 c-9 -32 -8 -41 4 -45 24 -10 35 4 28 37 -11 49 -21 52
-32 8z"/>
<path d="M7106 4333 c-3 -3 -6 -28 -6 -55 0 -41 3 -48 20 -48 25 0 44 35 36
66 -6 24 -38 48 -50 37z"/>
<path d="M7100 4110 c0 -53 2 -60 20 -60 23 0 40 28 40 67 0 33 -16 53 -42 53
-15 0 -18 -9 -18 -60z"/>
<path d="M3764 4183 c-8 -21 -16 -49 -17 -63 -2 -23 1 -24 38 -21 22 2 43 5
47 7 8 5 -34 114 -44 114 -4 0 -15 -17 -24 -37z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
